export default __webpack_public_path__ + "static/media/elevate-bpn-3.4eceb6ff.png";